/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_Enum_Study_Cultural_Anthropology25Inputs */

const en__field_enum_study_cultural_anthropology25 = /** @type {(inputs: _Field_Enum_Study_Cultural_Anthropology25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Cultural Anthropology and European Ethnology`)
};

const de__field_enum_study_cultural_anthropology25 = /** @type {(inputs: _Field_Enum_Study_Cultural_Anthropology25Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kulturanthropologie und Europäische Ethnologie`)
};

/**
* | output |
* | --- |
* | "Cultural Anthropology and European Ethnology" |
*
* @param {_Field_Enum_Study_Cultural_Anthropology25Inputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
const _field_enum_study_cultural_anthropology25 = /** @type {((inputs?: _Field_Enum_Study_Cultural_Anthropology25Inputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_Enum_Study_Cultural_Anthropology25Inputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en__field_enum_study_cultural_anthropology25(inputs)
	return de__field_enum_study_cultural_anthropology25(inputs)
});
export { _field_enum_study_cultural_anthropology25 as "_field_enum_STUDY_CULTURAL_ANTHROPOLOGY" }